var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    fill: "#2BBFDC",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.983 111.094H101.972V101.399C101.972 98.119 99.8843 94.025 97.2645 92.0788L87.2046 84.6333V83.3672L97.264 75.9217C99.8843 73.9756 101.971 69.8815 101.971 66.6018V56.9064H101.982C103.727 56.9064 105.135 55.4767 105.135 53.719V53.1874C105.135 51.4296 103.727 50 101.982 50H67.1663C65.4214 50 64 51.4296 64 53.1874V53.7184C64 55.4762 65.4203 56.9058 67.1652 56.9058L67.1797 66.6013C67.1797 69.8815 69.2295 73.9729 71.8552 75.9147L81.9312 83.3726V84.6269L71.8472 92.0853C69.2225 94.0271 67.1642 98.1185 67.1642 101.399V111.094H67.1663C65.4214 111.094 64 112.524 64 114.282V114.813C64 116.57 65.4214 118 67.1663 118H101.983C103.728 118 105.136 116.57 105.136 114.813V114.282C105.136 112.524 103.728 111.094 101.983 111.094ZM99.8618 111.095H97.2248V102.762C97.2248 100.34 95.7162 97.317 93.7799 95.8804L85.2197 89.5207C84.8484 89.2439 84.3432 89.2433 83.9713 89.5191L75.366 95.8847C73.4277 97.3192 71.9104 100.34 71.9104 102.762V111.094H69.2734V101.399C69.2734 98.8109 71.0312 95.3305 73.1019 93.7983L83.6118 86.0219C83.8824 85.8217 84.0399 85.5038 84.0399 85.1655V82.8351C84.0399 82.4967 83.8862 82.1788 83.6161 81.9786L73.0993 74.2023C71.028 72.6701 69.2734 69.1896 69.2734 66.6018V56.9064H99.8618V66.6018C99.8618 69.1907 98.081 72.6755 96.0119 74.212L85.5406 81.9754C85.2711 82.1756 85.0948 82.4924 85.0948 82.8302V85.1703C85.0948 85.5076 85.2539 85.825 85.5234 86.0252L96.0124 93.7891C98.0804 95.3256 99.8618 98.8104 99.8618 101.399V111.095Z",
    fill: "url(#paint0_linear_360_27250)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1637 70.933C94.0212 70.4964 93.6167 70.2023 93.1613 70.2023L75.9914 70.1969C75.5355 70.1969 75.1315 70.4921 74.989 70.9282C74.847 71.3648 74.9997 71.844 75.3672 72.116L83.9731 78.4811C84.159 78.6187 84.3781 78.6873 84.5972 78.6873C84.8169 78.6873 85.0371 78.6182 85.223 78.4795L93.7876 72.1198C94.154 71.8478 94.3062 71.3691 94.1637 70.933Z",
    fill: "url(#paint1_linear_360_27250)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_27250",
    x1: 64.0012,
    y1: 83.995,
    x2: 105.14,
    y2: 83.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_27250",
    x1: 64.0012,
    y1: 83.995,
    x2: 105.14,
    y2: 83.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.82d1a76160ffbc9954aba3e3664ee49d.svg";
export { ForwardRef as ReactComponent };